export const commonData = {
  map: {
    iframe: "https://www.google.com/maps?q=Outer%20Ring%20Road%20Lucknow&output=embed",
    caption:
      "Outer Ring Road (Kisan Path), nearby Lucknow-Ayodhya Highway Post Code: 225003 “Floret Town offers excellent connectivity to key areas and urban hubs.”",
  },
  video: {
    youtubeEmbed: "https://www.youtube.com/embed/DiNoPaKUESE?autoplay=1&mute=1&loop=1&playlist=DiNoPaKUESE&controls=0&rel=0&modestbranding=1&playsinline=1&disablekb=1",
    caption: "Watch the complete villa walkthrough and explore the lifestyle at Floret Town.",
  },
  cta: {
    text: "Book Now / Enquire Now",
    buttonText: "Enquire Now",
    redirect: "/contact",
  },
};
